module.exports = __webpack_public_path__ + "img/3.be1a0d9a.jpg";